import { render, staticRenderFns } from "./ProssimiTg.vue?vue&type=template&id=124f8506&scoped=true&"
import script from "./ProssimiTg.vue?vue&type=script&lang=js&"
export * from "./ProssimiTg.vue?vue&type=script&lang=js&"
import style0 from "./ProssimiTg.vue?vue&type=style&index=0&id=124f8506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124f8506",
  null
  
)

export default component.exports